import { createIconComponent } from '../../factory/create-icon-component';
export const UnknownIcon = createIconComponent(
  'UnknownIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="5" width="22" height="15" rx="2" fill="#EAEAEA" />
    <circle cx="12" cy="16" r="1" fill="#22272F" />
    <path
      d="M10 10.5V10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10V10.1213C14 10.6839 13.7765 11.2235 13.3787 11.6213L12 13"
      stroke="#22272F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'flag',
);
